/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ServiceEventCreateDto
 */
export interface ServiceEventCreateDto {
    /**
     * DeviceGroupTag of the ScheduledMaintenance DeviceGroup
     * @type {string}
     * @memberof ServiceEventCreateDto
     */
    scheduledMaintenanceDeviceGroupTag?: string;
    /**
     *
     * @type {Date}
     * @memberof ServiceEventCreateDto
     */
    scheduledDate?: Date;
}

/**
 * Check if a given object implements the ServiceEventCreateDto interface.
 */
export function instanceOfServiceEventCreateDto(
    value: object,
): value is ServiceEventCreateDto {
    return true;
}

export function ServiceEventCreateDtoFromJSON(
    json: any,
): ServiceEventCreateDto {
    return ServiceEventCreateDtoFromJSONTyped(json, false);
}

export function ServiceEventCreateDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ServiceEventCreateDto {
    if (json == null) {
        return json;
    }
    return {
        scheduledMaintenanceDeviceGroupTag:
            json["scheduledMaintenanceDeviceGroupTag"] == null
                ? undefined
                : json["scheduledMaintenanceDeviceGroupTag"],
        scheduledDate:
            json["scheduledDate"] == null
                ? undefined
                : new Date(json["scheduledDate"]),
    };
}

export function ServiceEventCreateDtoToJSON(
    value?: ServiceEventCreateDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        scheduledMaintenanceDeviceGroupTag:
            value["scheduledMaintenanceDeviceGroupTag"],
        scheduledDate:
            value["scheduledDate"] == null
                ? undefined
                : value["scheduledDate"].toISOString(),
    };
}
